import { round } from "utils";
import { getCommentAndColor } from "components/PerformanceReview/helpers";
import {
  CategoryMap,
  CategoryTips,
  PaceEnergyDynamicTips,
  SubCategoryData,
  SubCategoryMap,
} from "components/PerformanceReview/constants";

/** Score (0–100) → "0X/10", same as desktop ParameterwiseFeedback.parseScore. */
export function parseScore(value) {
  const n = round((value || 0) / 10);
  return n < 10 ? `0${n}/10` : `${n}/10`;
}

/**
 * "How to improve" tips for a parameter — ported from desktop
 * `ParameterwiseFeedback`'s Tips component. Returns the bullet list plus an
 * optional success message (shown instead of tips when the score is already
 * excellent).
 */
export function buildTips(featureData = {}) {
  const { category, score = 0, tags = [] } = featureData;
  const tips = [];
  let successMessage = null;

  switch (category) {
    case CategoryMap.FLUENCY:
      if (score > 90) break;
      tips.push(
        "Try to minimize above fluency mistakes, as it will help you improve your overall fluency."
      );
      break;

    case CategoryMap.DELIVERY: {
      let pace = "ideal";
      let energy = "ideal";
      (tags || []).forEach((feature) => {
        if (feature.subCategory === SubCategoryMap.PACE) {
          pace = SubCategoryData[SubCategoryMap.PACE].getTag(feature.value);
        } else {
          energy = SubCategoryData[SubCategoryMap.ENERGY].getTag(feature.value);
        }
      });
      const tip = PaceEnergyDynamicTips[`${pace}_${energy}`];
      if (pace === "ideal" && energy === "ideal") successMessage = tip;
      else if (tip) tips.push(tip);
      break;
    }

    case CategoryMap.WORD_CHOICE: {
      const grade = getCommentAndColor(score).label;
      const tip = CategoryTips?.[category]?.[grade] || [];
      if (grade === "VERY_GOOD" && !tags?.[0]?.value?.length) {
        successMessage = Array.isArray(tip) ? tip[0] : tip;
      } else {
        tips.push(...tip);
      }
      break;
    }

    case CategoryMap.CONFIDENCE:
    case CategoryMap.SIMILARITY:
    case CategoryMap.RELEVANCE:
    case CategoryMap.LOGIC_FLOW: {
      const grade = getCommentAndColor(score).label;
      const tip = CategoryTips?.[category]?.[grade] || [];
      if (grade === "VERY_GOOD") {
        successMessage = Array.isArray(tip) ? tip[0] : tip;
      } else {
        tips.push(...tip);
      }
      break;
    }

    default:
      break;
  }

  return { tips, successMessage };
}
